import { render, staticRenderFns } from "./assignDataRolesDialog.vue?vue&type=template&id=571b019e&"
import script from "./assignDataRolesDialog.vue?vue&type=script&lang=js&"
export * from "./assignDataRolesDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports